export default __webpack_public_path__ + "assets/grow-business.161233b9.svg";